import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';

import HealthList from './index';
import Direction from './direction';
import DirectionDetail from './direction/detail';
import Units from './units';
import UnitDetail from './units/detail';
import TimeTable from './timetable';
import TimeTableDetail from './timetable/detail';
import Experts from './experts';
import ExpertDetail from './experts/detail';

class HealthManagment extends Component {
	render() {

		const path = this.props.match.path;

		return (
      <div>
				<Switch>
					<Route exact path={`${path}`} component={HealthList}/>
					<Route exact path={`${path}/direction`}  component={Direction}/>
					<Route exact path={`${path}/direction/detail/:direction_id`}  component={DirectionDetail}/>
					<Route exact path={`${path}/units`} component={Units}/>
					<Route exact path={`${path}/units/detail`} component={UnitDetail}/>
					<Route exact path={`${path}/timetable`} component={TimeTable}/>
					<Route exact path={`${path}/timetable/detail/:timetable_id`} component={TimeTableDetail}/>
					<Route exact path={`${path}/experts`} component={Experts}/>
					<Route exact path={`${path}/experts/:page`} component={Experts}/>
					<Route exact path={`${path}/experts/detail/:expert_id`} component={ExpertDetail}/>
				</Switch>
	    </div>
    );
	}
}

export default HealthManagment;



// WEBPACK FOOTER //
// ./src/system/management/router.js